/**
 * @Author: Zewei
 * @Date:   2018-02-07T11:22:51+08:00
 * @Last modified by:
 * @Last modified time: 2018-02-27T14:52:15+08:00
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { linkToNewRouter } from '../../actions/employee-management-actions.js';
import { Table, Button } from 'antd';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';

let currentYear = new Date().getFullYear(),
    currentMonth = new Date().getMonth() + 1,
    data = [];
for (let i = 0; i < 12; i++) {
  let stringifyMonth, date;
  currentMonth = currentMonth - 1;
  if (currentMonth === 0) {
      currentMonth = 12;
      currentYear = currentYear - 1;
  }
  stringifyMonth = `${currentMonth}`.length > 1 ? `${currentMonth}` : `0${currentMonth}`;
  date = `${currentYear}-${stringifyMonth}`;
  data.push({
    key: i,
    num: i + 1,
    date: date,
  });
}

const mapStateToProps = state => ({
employeeManagement: state.employeeManagement,
});
const mapDispatchToProps = { linkToNewRouter };

@connect(mapStateToProps, mapDispatchToProps)
class MonthyReport extends Component {

      handleOpenDetail = (date) => {
          let url = `monthy-report-detail/${date}`;
          this.props.linkToNewRouter(url)
      }

      columns = [{
          title: '#',
          dataIndex: 'num',
          key: 'num',
          width: 300,
        }, {
          title: '月度',
          dataIndex: 'date',
          key: 'date',
          width: 300,
        }, {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          width: 300,
          render: (text, record) => (
            <span>
                <Button icon="info-circle-o" onClick={this.handleOpenDetail.bind(this, record.date)} size="small" className="row-action-btn">查看</Button>
            </span>
          ),
        }];

      render() {

          return (
              <div className="app-module-item">
                  <Table
                      columns={this.columns}
                      dataSource={data}
                      rowKey={record => record.date}
                      // pagination={paginationCfg}
                  />
              </div>
          )
      }
  }

 MonthyReport = LayoutWrapper(MonthyReport)

 export default MonthyReport;



// WEBPACK FOOTER //
// ./src/routes/EmployeeManagement/MonthyReport.js